module.exports = __webpack_public_path__ + "static/media/default-community-icon.d265941b.svg";